import { colors } from '@/theme/colors';
import styled from 'styled-components';
import R2PlayerRegistation from './R2PlayerRegistation';
import VerifiedCenterRegistration from './VerifiedCenterRegistration';
import { useCallback, useEffect, useMemo } from 'react';
import { useLoading } from '@/context/LoadingContext';
import { getPartnerServiceOptions } from '@/api/service-regist/getPartnerServiceOptions';
import { useAppSelector } from '@/stores/hooks';
import { useDispatch } from 'react-redux';
import { service } from '@/stores/slices/service-regist/serviceSlices';

const ServiceRegistrationPage = () => {
  const { startLoading, stopLoading } = useLoading();
  const { partnerServiceOptions } = useAppSelector((state) => state.service);
  const dispatch = useDispatch();

  const fetchPartnerService = useCallback(async () => {
    startLoading();
    try {
      const res = await getPartnerServiceOptions();
      if (res.isSuccess) {
        dispatch(service.setPartnerServiceOptions(res.data));
      }
    } finally {
      stopLoading();
    }
  }, [dispatch, startLoading, stopLoading]);

  useEffect(() => {
    fetchPartnerService();
  }, [fetchPartnerService]);

  const allServices = partnerServiceOptions
    .filter(
      (item) =>
        item.serviceType === 'CROWN_BRIDGE' ||
        item.serviceType === 'SURGICAL_GUIDE'
    )
    .map((item) => item);

  const verifiedServices = partnerServiceOptions
    .filter(
      (item) =>
        item.serviceType === 'R2_QVD' ||
        item.serviceType === 'FACE_GIDE' ||
        item.serviceType === 'MEG_ALIGNER'
    )
    .map((item) => item);

  return (
    <Container>
      <R2PlayerRegistation data={allServices} />
      <VerifiedCenterRegistration data={verifiedServices} />
    </Container>
  );
};

export default ServiceRegistrationPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: ${colors.white};
  gap: 85px;
  padding: 53.5px 0 0 13px;
`;
